<template>
  <v-btn icon to="/ai-review" class="mr-2">
    <v-badge :content="aiJobStore.completedCount" :model-value="aiJobStore.completedCount > 0" color="error" floating>
      <v-icon :color="aiJobStore.pendingCount > 0 ? 'accent' : 'white'">
        mdi-creation
      </v-icon>
    </v-badge>
    <v-tooltip activator="parent" location="bottom">
      AI Results
      <span v-if="aiJobStore.pendingCount > 0">({{ aiJobStore.pendingCount }} processing)</span>
    </v-tooltip>
  </v-btn>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAiJobStore } from '@/stores/aiJobStore'

const aiJobStore = useAiJobStore()

onMounted(() => {
  aiJobStore.bindJobs()
})
</script>
